"use strict";
angular.module("productMangageMentNewspaperServiceModule", [
        "productManageMentNewspaperEnableViewsModule",
        "productManageMentNewspaperDeleteViewsModule",
        "productManageMentNewspaperDisableViewsModule",
        'initAllocationDataModule',
        'productManageMentNewClassifyModule',
        // 'typeclassifySettingPageManageModule',
        'productNewsPaperDistributeAddModule',
        'productManageMentNewpaperCommOrderModule',
    ])
    .factory("productMangageMentNewspaperService", ["$modal", "$q", "trsHttpService", "globleParamsSet", function($modal, $q, trsHttpService, globleParamsSet) {
        return {
            //新建or编辑报纸
            manageNews: function(selectedItem, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/service/manageNewspaper/manageNewspaper_tpl.html",
                    windowClass: 'manageNewsAdd',
                    backdrop: false,
                    resolve: {
                        selectedItem: function() {
                            return selectedItem;
                        }
                    },
                    controller: "manageNewsCtrl"
                });
                modalInstance.result.then(function(result) {
                    if (result === "success") {
                        success();
                    }
                });
            },
            //报刊排序
            commOrder: function(sortInfo, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/commOrder/commOrder_tpl.html",
                    windowClass: 'newpaper_comm_order',
                    backdrop: false,
                    resolve: {
                        sortInfo: function() {
                            return sortInfo;
                        }
                    },
                    controller: "productManageMentNewpaperCommOrderCtrl"
                });
                return modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            //批量删除
            batchDelete: function(widgetId, chnlName, $scope, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/service/batchDelete/batchDelete_tpl.html",
                    scope: $scope,
                    windowClass: 'man_produ_newpress',
                    backdrop: false,
                    controller: "productManageMentBatchDeleteCtrl",
                    resolve: {
                        widgetParams: function() {
                            return {
                                widgetId: widgetId,
                                chnlName: chnlName
                            };
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            //启用弹窗
            enableViews: function(widgetId, chnlName, $scope, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/service/enable/newspaper_enable_tpl.html",
                    scope: $scope,
                    windowClass: 'productManageMent-newspaper-enableViews',
                    backdrop: false,
                    controller: "productManageMentNewspaperEnableViewsCtrl",
                    resolve: {
                        widgetParams: function() {
                            return {
                                widgetId: widgetId,
                                chnlName: chnlName
                            };
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            //停用弹窗
            disableViews: function(widgetId, chnlName, $scope, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/service/delete/newspaper_enable_tpl.html",
                    scope: $scope,
                    windowClass: 'productManageMent-newspaper-disableViews',
                    backdrop: false,
                    controller: "productManageMentNewspaperDisableViewsCtrl",
                    resolve: {
                        widgetParams: function() {
                            return {
                                widgetId: widgetId,
                                chnlName: chnlName
                            };
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            //删除弹窗
            deleteViews: function(ObjectIds, chnlName, $scope, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/service/delete/newspaper_delete_tpl.html",
                    scope: $scope,
                    windowClass: 'productManageMent-newspaper-deleteViews',
                    backdrop: false,
                    controller: "productManageMentNewspaperDeleteViewsCtrl",
                    resolve: {
                        widgetParams: function() {
                            return {
                                ObjectIds: ObjectIds,
                            };
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            /**
             * [getRight description]获取栏目或站点的操作权限
             * @return object [description]
             */
            getRight: function(siteId, channelId, classify) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperKeyById",
                    SiteId: siteId,
                    ChannelId: channelId,
                    Classify: classify
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            },
            /**
             * [getOperType description]获取可以看到或操作的底部标签 如：频道管理，碎片化管理，模板管理，分发配置
             * @return object [description]
             */
            getOperType: function(siteId, channelId) {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryOperTypesBySiteId",
                    ChannelId: channelId,
                    SiteId: siteId
                };
                if (siteId === "") {
                    delete params.SiteId;
                } else {
                    delete params.ChannelId;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            },

            //新建修改分类弹窗
            newAndEditClassify: function(params) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/newClassify/newClassify_tpl.html",
                    windowClass: 'newclassifywindow',
                    backdrop: false,
                    controller: "productManageMentNewClassifyCtrl",
                    resolve: {
                        params: function() {
                            return params;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            },
            //分发配置增加
            /*addClassifyManagement: function(item, successFn) {
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/distributeConfig/template/addView_tpl.html",
                    windowClass: 'newspaperdistribute-add ',
                    backdrop: false,
                    controller: "newsPaperDistributeAddCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                });
                return modalInstance.result.then(function(result) {
                    successFn(result);
                });
            },*/
            addClassifyManagement: function(item, paperid) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/productManageMent/newspaper/distributeConfig/template/addView_tpl.html",
                    windowClass: 'newspaperdistribute-add ',
                    backdrop: false,
                    controller: "newsPaperDistributeAddCtrl",
                    resolve: {
                        item: function() {
                            return item;
                        },
                        paperid: function() {
                            return paperid;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
        };
    }]);
